module.exports = __webpack_public_path__ + "img/checkbox_check.acccf6cc.svg";